import { useMemo } from "react";
import { bindActionCreators } from "@reduxjs/toolkit";
import { tabActions } from "redux/actions";
import { useAppDispatch, useAppSelector } from "redux/store";

export const useTab = () => {
  const state = useAppSelector((state) => state.tabReducer);
  const dispatch = useAppDispatch();
  const actions = useMemo(
    () => bindActionCreators(tabActions, dispatch),
    [dispatch]
  );

  return { state, actions };
};
